import * as React from "react";
type Props = {
  className?: string,
};
function SvgDislike({ className }: Props) {
  return (
    <svg
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Dislike"
      className={className}
    >
      <path
        d="M29.7531 5.9707C-1.19811 20.8727 -1.19654 65.5833 9.12263 83.9271C19.4402 102.271 48.1001 124.055 81.3427 110.299C114.587 96.5424 127.194 41.5142 100.961 38.7528C78.4431 36.3844 64.921 2.95007 41.9692 2.95007C38.1816 2.95007 34.1379 3.85846 29.7531 5.9707Z"
        fill="#C5D9E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9438 59.0504C19.9438 37.4519 37.4525 19.9433 59.0524 19.9433C69.2488 19.9433 78.5344 23.8452 85.4968 30.238C93.2804 37.3869 98.1595 47.6483 98.1595 59.0504C98.1595 80.6489 80.6509 98.159 59.0524 98.159C37.4525 98.159 19.9438 80.6489 19.9438 59.0504Z"
        fill="white"
      />
      <path
        d="M70.1146 45.0287L83.4766 28.8446M33.7003 88.4991L51.5029 66.8772M69.7604 44.6035C62.9338 42.5199 59.861 49.6129 59.4088 49.7008C58.9585 49.6129 56.4345 42.5163 48.8643 44.6035C44.9022 45.6966 40.6318 51.0923 45.7801 59.5236C49.4092 65.4685 56.8299 72.1257 57.9065 72.8178C58.9945 73.519 59.8062 73.5337 60.8298 72.8306C61.9083 72.0928 69.5031 65.2012 72.9354 59.5437C76.5341 53.6098 75.2872 46.2898 69.7604 44.6035ZM19.9438 59.0504C19.9438 37.4519 37.4525 19.9433 59.0524 19.9433C69.2488 19.9433 78.5344 23.8452 85.4968 30.238C93.2804 37.3869 98.1595 47.6483 98.1595 59.0504C98.1595 80.6489 80.6509 98.159 59.0524 98.159C37.4525 98.159 19.9438 80.6489 19.9438 59.0504Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgDislike;
